// extracted by mini-css-extract-plugin
module.exports = {"container":"livestream-event-EventCollectionFooter__container--2eu3U","btn":"livestream-event-EventCollectionFooter__btn--EcgVL"};